$(() => {
  // handle checkbox toggle
  $("#share-photos-toggle").on("change", function() {
    $(".checkbox-toggle").addClass('hidden');
    $("#share-preference-loader").removeClass('hidden');

    const errorMessage = "An unexpected error occurred!"

    $.ajax({
      type: 'PUT',
      url: "/accounts/update_share_photos_preference",
      data: { share_photos: this.checked },
      success: (data) => {
        window.location.reload();
      },
      error: () => {
        alert(errorMessage)
        window.location.reload()
      },
    });
  });
});



// WEBPACK FOOTER //
// ./app/components/dashboard/photos_component/photos_component.js